import { CartItemLogic } from '../../../features/cart-item';
import { findPriceForQuantity } from '../../../features/pricing';
import { Card, FetchStatusType, Item } from '../../../types/interfaces';
import { CART_ROW_GRID_COLS, CartItemUI } from './CartItemUI';


interface CartSummaryProps {
  product: Card;
  status: FetchStatusType;
}

function computeItemPrices(item: Item & { verification_item: any }): Item {
  const price = findPriceForQuantity(item.prices, item.quantity);
  const vp = item.verification_item
    ? findPriceForQuantity(item.verification_item.prices, item.verification_quantity)
    : 0;
  return {
    ...item,
    totalPrice: price * item.quantity + vp * item.verification_quantity,
    verificationTotalPrice: vp * item.verification_quantity,
  };
}

export const CartSummary = ({ product, status }: CartSummaryProps) => {
  const cartItems = product.items?.filter((item) => (item as any).inCart) ?? [];

  if (cartItems.length === 0) return null;
  if (status === 'loading') return null;

  return (
    <div className="border border-[#D0D3D8] rounded-2xl overflow-hidden bg-white flex flex-col">
      <div className="px-6 py-4 bg-[#F5F6FA] border-b border-gray-200 shrink-0">
        <span className="text-base font-semibold text-[#141414]">В корзине:</span>
      </div>
      <div className="overflow-x-auto">
        <div
          className="grid items-center gap-x-4 px-6 py-3 border-b border-gray-100 bg-white"
          style={{ gridTemplateColumns: CART_ROW_GRID_COLS }}
        >
          <span className="text-sm text-[#9CA0A7]">Наименование</span>
          <span className="text-sm text-[#9CA0A7]">Количество</span>
          <span className="text-sm text-[#9CA0A7]">Поверка</span>
          <span className="text-sm text-[#9CA0A7]">Сумма</span>
          <span />
        </div>
        {cartItems.map((item) => (
          <CartItemLogic
            key={item.id}
            item={computeItemPrices({
              ...item,
              verification_item: item.verification_item ?? product.verification_item,
            })}
            CartItemUI={(props) => (
              <CartItemUI
                {...props}
                onVerificationQuantityChange={(v) =>
                  props.onVerificationQuantityChange(Math.min(v, props.quantity))
                }
              />
            )}
          />
        ))}
      </div>
    </div>
  );
};
